export enum user_status {
    Enabled = 'Activado',
    Disabled = 'Desactivado',
    Deleted = 'Deleted',
    All = 'Todos',
    DefaulStatus = Enabled,
    DefaultFilter = All
}
